import styled from 'styled-components'

import Button from '@/common/components/Button'

export const SubmitButton = styled(Button).attrs({
  className: 'text-14 mt-12',
  type: 'submit',
  variant: 'filled',
  fullWidth: true,
})`
  height: 26px;
`
